import ThreeCardOracleSpread from '../../components/oracle/ThreeCardOracleSpread';
import TripleEnergySpread from '../../components/oracle/TripleEnergySpread';

const TripleEnergySpreadPage = ({lang = 'es'}) => {

  return (
    <div className="bg-gray-900 min-h-screen pt-16">
      {/* Usa el componente con el nuevo nombre */}
      <TripleEnergySpread lang={lang} />
    </div>
  );
};

export default TripleEnergySpreadPage;